<script setup>
import { provide } from 'vue';
import TopBlock from "@/components/TopBlock";
import InfoBlock from "@/components/InfoBlock";
import InfoCards from "@/components/InfoCards";
import RationBlock from "@/components/RationBlock";
import ProteinInfo from "@/components/ProteinInfo";
import TutorialBanner from "@/components/TutorialBanner";
import UsefulMaterials from "@/components/UsefulMaterials";
import { catalogPuppy, catalogAdult } from "@/data/products";

const DLEvent = (eventName, ParameterName1 = 'click', ParameterValue1 = 'click', ParameterName2 = null, ParameterValue2 = null) => {
  const baseEvent = {
    event: 'DLevent',
    eventName: eventName
  };

  let eventData;

  if (ParameterName2 && ParameterValue2) {
    eventData = {
      ParameterName1: ParameterName1,
      ParameterValue1: ParameterValue1,
      ParameterName2: ParameterName2,
      ParameterValue2: ParameterValue2
    };
  } else {
    eventData = {
      ParameterName1: ParameterName1,
      ParameterValue1: ParameterValue1,
    };
  }
  dataLayer.push({...baseEvent, ...eventData});
}

provide('DLEvent', DLEvent);

</script>

<template>
  <top-block/>
  <info-block/>
  <info-cards/>
  <ration-block
      :catalog="catalogPuppy"
      title="Рационы PRO PLAN<sup>®</sup> разработаны с&nbsp;учётом разных потребностей щенка"
  />
  <protein-info/>
  <ration-block
      :catalog="catalogAdult"
      title="переведите питомца на&nbsp;рацион для&nbsp;взрослых собак"
      is-adult
  />
  <tutorial-banner/>
  <useful-materials/>
</template>
